import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { TranslationModule } from '@df/ui/translation/translation.module';

export interface IPaymentsBasketView {
    icon: string;
    name: string;
}

@Component({
    selector: 'basket-view-paywith',
    templateUrl: './basket-view-paywith.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslationModule, DfModuleImageModule]
})
export class BasketViewPaywithComponent {
    @Input()
    payments: IPaymentsBasketView[] = [];
}
